import useTranslation from 'next-translate/useTranslation';

import clsx from 'clsx';

import { MENTION_ICON } from '@/lib/manage/mentions';

import Icon from '@/components/base/Icon';

export const MentionedIn = ({ large, mentionCount = '', mentionType }) => {
    const { t } = useTranslation('conversations');

    return (
        <div
            className={clsx('flex w-fit rounded bg-icoGray-300 align-middle dark:bg-white/10', {
                'gap-1 p-3': large,
                'gap-2 px-2 py-1': !large
            })}>
            <Icon
                icon={MENTION_ICON?.[mentionType]}
                className="text-xs text-icoGray-500 dark:text-white"
            />
            <p className="text-xs text-icoGray-500 dark:text-white">
                {mentionCount ? <span className="mr-1">{mentionCount}</span> : null}
                {t(`mentions_tracker.mention.${mentionType}`, { count: mentionCount })}
            </p>
        </div>
    );
};
